<template>
  <div>
    <div class="snippet event-domain-snippet">
      <div
        class="form-group row"
        v-for="section in sortedSections"
        :key="section.key"
      >
        <div class="col-lg-8">
          <label class="font-weight-bold"> {{ section.label }}</label>
          <br />

          <div class="custom-control custom-switch">
            <input-switch
              :name="section.key"
              :value="section.is_show"
              class="custom-control-input"
              :id="`switch-${section.key}`"
              @change="toggleSection(section.key)"
            />
            &nbsp;&nbsp;
            <div class="col-lg-8 mt-2">
  <label>Section Label</label>
  <input
    type="text"
    class="form-control"
    :value="section.label"
    @input="updateSection(section.key, { label: $event.target.value })"
    placeholder="Enter section label"
  />
</div>

            <label
              class="custom-control-label"
              :for="`switch-${section.key}`"
              :class="section.is_show ? 'text-success' : 'text-danger'"
            >
              {{ section.is_show ? "Enabled" : "Disabled" }}
            </label>
          </div>
        </div>

        <!-- Sort Order Field -->
        <div class="col-lg-8 mt-2">
          <label>Display Order</label>
          <input
            type="number"
            class="form-control"
            :value="section.sort_order"
            min="1"
            @input="updateSection(section.key, { sort_order: parseInt($event.target.value) })"
          />
        </div>

        <!-- Additional Inputs for Welcome Note -->
        <template v-if="section.key === 'welcome_note' && section.is_show">
          <div class="col-lg-8 mt-3">
            <label>Welcome Note Heading</label>
            <input
              type="text"
              class="form-control"
              :value="section.welcome_note_heading"
              @input="updateSection(section.key, { welcome_note_heading: $event.target.value })"
              placeholder="Enter the heading for the welcome note"
            />
          </div>

          <div class="col-lg-8 mt-3">
            <label>Welcome Note Content</label>
            <input
              type="text"
              class="form-control"
              :value="section.welcome_note_text"
              @input="updateSection(section.key, { welcome_note_text: $event.target.value })"
              placeholder="Enter the welcome note text"
            />
          </div>

          <div class="col-lg-8 mt-3">
            <label>Welcome Note Image</label>
            <DropFiles
              :file="validate_file(section.welcome_note_image)"
              :module_id="item._id"
              @onUploaded="updateWelcomeImage"
              @onRemoved="removeWelcomeImage"
              accept="image/jpeg"
              module_type="events"
              asset_type="welcome_note_image"
              dimmention="440X400"
              @onError="errCb"
            >
              <template #header>
                 <label>(Should be in image  with dimmention 440X400)</label>
              </template>
              <template #tooltip>
                <VTooltip style="display:inline-block">
                  <i class="fa fa-info-circle" style="font-size:16px"></i>
                  <template #popper>
                    <img src="/admin_assets/img/event_garden_smallbanner_5.png" />
                  </template>
                </VTooltip>
              </template>
            </DropFiles>
          </div>
        </template>

        <div class="col-12"><hr /></div>
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { mapGetters, mapActions } from "vuex";
  import InputSwitch from "@/components/Commons/InputSwitch";
  import _ from "lodash";
  
  export default {
    name: "MidSectionTab",
    components: { InputSwitch },
    computed: {
      ...mapGetters("LandingPageSettingsSingle", ["item"]),
      sortedSections() {
        return this.item.mid_section;
        //return _.sortBy(this.item.mid_section, "sort_order");
      },
    },
    methods: {
      ...mapActions("LandingPageSettingsSingle", ["updateMidSectionByKey","setWelcomeImage"]),
      validate_file(fileInfo) {
        if (_.has(fileInfo, "key")) return fileInfo;
        return null;
      },
      toggleSection(key) {
        const section = this.item.mid_section.find((s) => s.key === key);
        if (section) {
          this.updateMidSectionByKey({
            key,
            updates: { is_show: !section.is_show },
          });
        }
      },
      updateSection(key, updates) {
        this.updateMidSectionByKey({ key, updates });
      },
      updateWelcomeImage(info,data){
        const key = _.get(this.item.welcome_note_image, 'key', null);
        const size = _.get(info, 'file.size', 0);

        let fileKey = data.data.key?data.data.key:data.data.Key; 
        const extension = fileKey.split('.').pop();
        this.setWelcomeImage({
        old_key: key,
        key: fileKey,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2025.01.01',
        });
      },
      removeWelcomeImage(e){
        this.setWelcomeImage(null);
      },
      errCb(e){
            this.$flashMessage.show({
                group : 'landing_page_index',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        },
    },
  };
  </script>
  